export default "__VITE_PUBLIC_ASSET__15e8e18c__"